<!--
    描述：系统全局配置
    时间：2020-04-28
    Created by ws
-->
<template>
	<div class="setting-main">
		<el-tooltip effect="light"
					placement="bottom"
					content="配置">
			<svg-icon icon-class="setting"
					  @click.prevent.stop="showSetting"></svg-icon>
		</el-tooltip>

		<!-- 配置项侧滑 -->
		<el-drawer :with-header="false"
				   :visible.sync="drawerObj.visible"
				   :size="drawerObj.size">
			<h1 class="drawer-title">{{ drawerObj.title }}</h1>
			<!-- <div class="setting-item">
				<div class="left">
					是否显示头部
				</div>
				<div class="right">
					<el-switch v-model="isShowHeader"
							   active-text="是"
							   inactive-text="否"
							   @change="handleChange($event, 'showHeader')">
					</el-switch>
				</div>
			</div> -->
			<div class="setting-item">
				<div class="left">
					是否开启项目页面缓存
				</div>
				<div class="right">
					<el-switch v-model="isCachePages"
							   active-text="是"
							   inactive-text="否"
							   @change="handleChange($event, 'cachePages')">
					</el-switch>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
	data() {
		return {
			drawerObj: {
				visible: false,
				title: '系统配置项',
				size: '300px'
			},
			isShowHeader: false,	 // 是否展示头部
			isCachePages: true,		// 是否缓存页面
		}
	},
	methods: {
		...mapActions('settings', ['changeSetting']),
		...mapMutations('tags', ['DEL_ALL_CACHE_TAG']),
		// 展示配置侧滑
		showSetting() {
			this.drawerObj.visible = true
		},

		// 切换显示
		handleChange(val, key) {
			this.drawerObj.visible = false
			setTimeout(() => {
				this.changeSetting({
					key: key,
					value: val
				})

				if (key === 'cachePages') {
					this.DEL_ALL_CACHE_TAG()
				}
			}, 300)
		}
	},
	created() {
		this.isShowHeader = this.showHeader
	},
	computed: {
		...mapState('settings', {
			showHeader: state => state.showHeader
		})
	}
}
</script>

<style scoped lang="less">
.drawer-title {
	padding: 10px;
	color: #333;
	font-size: 20px;
}

.setting-item {
	height: 30px;
	line-height: 30px;
    padding: 0 10px;
    color: #333;
    font-size: 14px;
	display: flex;
	justify-content: space-between;
}
</style>
